import { faSquareRss, faAngleDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "gatsby"
import React from "react"

export const Head = () => (
  <div className="py-5">
    <h1 className="is-inline is-size-4 has-text-weight-bold mr-2 mb-3 blog-category">
      <Link to={"/blog"}>
        Spring blog
      </Link>
    </h1>
    <div className="secondary-nav">
      <div className="blog-nav-category">
        <Link to={"/blog"} className="is-link">
          All Posts
        </Link>
      </div>
      <div className="blog-nav-category">
        <Link to={"/blog/category/engineering"} className="is-link">
          Engineering
        </Link>
      </div>
      <div className="blog-nav-category">
        <Link to={"/blog/category/releases"} className="is-link">
          Releases
        </Link>
      </div>
      <div className="blog-nav-category">
        <Link to={"/blog/category/news"} className="is-link">
          News and Events
        </Link>
      </div>
    </div>
    <div className="blog-nav-rss">
      <div className="dropdown is-right is-hoverable">
        <div className="dropdown-trigger">
          <button
            className="rss-dropdown is-link is-size-6"
            aria-haspopup="true"
            aria-controls="RSS"
          >
            <FontAwesomeIcon
              className="mr-2"
              icon={faSquareRss}
              style={{ width: 15 }}
            />
            <span>RSS feeds</span>
            <FontAwesomeIcon
              className="icon is-small ml-2"
              icon={faAngleDown}
              style={{ width: 15 }}
            />
          </button>
        </div>
        <div className="dropdown-menu" role="menu">
          <div className="dropdown-content">
            <div className="dropdown-item">
              <Link
                to={"/blog.atom"}
                className="is-size-6 is-link mr-5"
                aria-label="RSS feed"
              >
                <FontAwesomeIcon
                  className="ml-1"
                  icon={faSquareRss}
                  style={{ width: 15 }}
                />
                {` `}
                All Posts
              </Link>
            </div>
            <div className="dropdown-item">
              <Link
                to={"/blog/category/engineering.atom"}
                className="is-size-6 is-link mr-5"
                aria-label="RSS feed"
              >
                <FontAwesomeIcon
                  className=" ml-1"
                  icon={faSquareRss}
                  style={{ width: 15 }}
                />
                {` `}
                Engineering
              </Link>
            </div>

            <div className="dropdown-item">
              <Link
                to={"/blog/category/releases.atom"}
                className="is-size-6 is-link mr-5"
                aria-label="RSS feed"
              >
                <FontAwesomeIcon
                  className="ml-1"
                  icon={faSquareRss}
                  style={{ width: 15 }}
                />
                {` `}
                Releases
              </Link>
            </div>
            <div className="dropdown-item">
              <Link
                to={"/blog/category/news.atom"}
                className="is-size-6 is-link mr-5"
                aria-label="RSS feed"
              >
                <FontAwesomeIcon
                  className="ml-1"
                  icon={faSquareRss}
                  style={{ width: 15 }}
                />
                {` `}
                News and Events
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
